import _ from 'lodash';

export const humanize = (str) => {
  return titleize(_.capitalize(_.trim(_.snakeCase(str).replace(/_id$/, '').replace(/_/g, ' '))));
};

export const titleize = (str) => {
  return str.toLowerCase().replace(/(?:^|\s|-)\S/g, (m) => m.toUpperCase());
};
